import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const CocosIslands: Country = {
    identifier: "CocosIslands",
    name: "Cocos (Keeling) Islands",
    countryCode: "CC",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇨🇨",
    svgPath: "m 746.67575,497.1434 0.033,0.015 0.043,-0.015 0.018,0.018 -0.067,0.028 -0.042,-0.051 -0.02,-0.083 -0.005,-0.07 0.019,0 0,0.028 0.005,0.023 0.015,0.046 -0.011,0.031 0.012,0.03 z m 0.219,0.035 -0.032,0.016 -0.028,-0.012 -0.008,-0.009 -0.003,-0.015 0.032,-0.002 0.025,-0.014 0.016,-0.024 0.005,-0.034 0.013,0.033 -0.002,0.033 -0.018,0.028 z",
}
